import { useEffect, useState } from "react";
import "./CopyContentPopup.scss";
import ModalContainer from "../ModalContainer";
import { copyOrganization } from "../../../services/organizations.service";
import useNotification from "../../../hooks/notification.hook";
import OrganizationsPickerTable from "../../utils/OrganizationsPickerTable";
import { useOrganizationPicker } from "../../../context/organizations-picker.context";

export default function CopyContentModal({ open, setOpen, loadingData, selectedConfId, plan }) {
	const {
		setFilteredList,
		organizations,
		setFilterType,
		setFilterResellers,
		selectedEntity,
		setSelectedEntity,
	} = useOrganizationPicker();

	const [loading, setLoading] = useState(false);

	const { openNotification, helperErrorNotification } = useNotification();

	useEffect(() => {
		if (open) {
			setSelectedEntity([]);
			setFilteredList(organizations);
			setFilterType([]);
			setFilterResellers([]);
		}
	}, [open, organizations]);

	/**
	 * Form Handler
	 * @param {form modal} data
	 */
	async function confirmCopy() {
		if (selectedEntity.length > 0) {
			if (!loading) {
				setLoading(true);

				const body = {
					idCorp: plan.organization_id,
					idPlan: plan.id,
					organization_plan_ids: selectedEntity.map((el) => el.organization_plans[0].id),
					...(selectedConfId && { copier_id: selectedConfId }),
				};

				// copy conf
				copyOrganization(
					body,
					() => {
						openNotification({
							text: "Operazione completata con successo!",
							status: "success",
						});

						setLoading(false);

						setOpen(false);
					},
					(err) => {
						helperErrorNotification(err);

						setLoading(false);
					}
				);
			}
		}
	}

	useEffect(() => {
		if (open) {
			setSelectedEntity([]);
		}
	}, [open]);

	return (
		<ModalContainer isOpen={open} setIsOpen={setOpen}>
			<div className="main_modal_content copy_plan_popup">
				<button
					className="main_close"
					onClick={() => setOpen(false)}
					type="button"
					aria-label="Chiudi"
				>
					<span className="icon_10 default close icon_mask !bg-white"></span>
				</button>

				<div className="main_header_modal">
					<span className="title">Enti di destinazioni copia contenuto</span>
				</div>

				<div className={"main_body_modal"}>
					<OrganizationsPickerTable loadingData={loadingData} />
				</div>

				<div className="main_footer_modal">
					<div className="right_content">
						{/* Main Cta */}
						<button type="button" onClick={confirmCopy} className="button fill success">
							Conferma
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
}
